import { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import {getDetail, getManagementHistoryList} from '../../../../service/setup/UnitOfMeasurement/UomService';
import { validUOM } from '../validation-uom';
import { t } from 'i18next';
import { validateSubmit } from '../../../../util';
import * as UOMServices from '../../../../service/setup/UnitOfMeasurement/UomService';
import { onChanged } from '../../../../util/Util';
import moment from "moment";

function useEditUOM() {
  const { token } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);
  const [visible, setVisible] = useState(false);
  const [uom_category, setUomCategory] = useState("");
  const [uom_name, setUomName] = useState("");
  const [uom_category_code, setUomCategoryCode] = useState("");
  const [uom_conversions_to, setUomConversionsTo] = useState(null);
  const [uom_description, setUomDescription] = useState("");
  const [updated_at, setUpdatedAt] = useState("");
  const [error, setError] = useState([]);
  const [err, setErr] = useState("");
  const [id, setId] = useState(null);
  const [successMessages, setSuccessMessages] = useState("");
  const [failedMessages, setFailedMessages] = useState("");
  const [failedModalOpen, setFailedModalOpen] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false)
  const [isChanged, setIsChanged] = useState(false)
  const [managementHistoryList, setManagementHistoryList] = useState([])

  const getDetailUOM = async () => {
    try {
      const response = await getDetail(token, null, id, dispatch);
      if (response && response.ok) {
        setData(response?.data);
        initiateData(response?.data);
        setLoading(false);
      }
    } catch (error) {
      return error;
    }
  }

  useEffect(() => {
    if (id === null) {
      setId(location?.state?.id);
    } else {
      getDetailUOM();
      doGetManagementHistoryList(id)
    }

    // eslint-disable-next-line
  }, [id]);

  const initiateData = (data) => {
    setUomCategory(data?.uom_category);
    setUomName(data?.uom_name);
    setUomCategoryCode(data?.uom_category_code);
    setUomConversionsTo(data?.uom_conversions_to);
    setUomDescription(data?.uom_description);
    setUpdatedAt(data?.updated_at);
  }

  const handleBack = () => {
    const prevPage = location?.state?.prevPage;

    if (!isChanged) {
      if (prevPage.includes('detail')) {
        navigate(prevPage, { state: { id: location?.state?.id, prevPage } })
      } else {
        navigate(prevPage);
      }
    } else {
      setShowConfirm(true)
    }
  }

  const _onChange = (evt, namespace) => {
    setErr("");

    onChanged(dispatch, true)
    setIsChanged(true)

    switch (namespace) {
      case 'uom_category':
        let erorCategory = validUOM(namespace, evt, t);
        setError({ ...error, ...erorCategory })
        setUomCategory(evt)
        break;
      case 'uom_name':
        let erorName = validUOM(namespace, evt.target.value, t);
        setError({ ...error, ...erorName })
        setUomName(evt.target.value)
        break;
      case 'uom_category_code':
        let erorCategoryCode = validUOM(namespace, evt.target.value, t);
        setError({ ...error, ...erorCategoryCode })
        setUomCategoryCode(evt.target.value)
        break;
      case 'uom_conversions_to':
        let erorConvertTo = validUOM(namespace, evt.target.value, t);
        setError({ ...error, ...erorConvertTo })
        setUomConversionsTo(evt.target.value)
        break;
      case 'uom_description':
        let erorDescription = validUOM(namespace, evt.target.value, t);
        setError({ ...error, ...erorDescription })
        setUomDescription(evt.target.value)
        break;

      default:
        break;
    }
  }

  const _onSave = async () => {
    let errors = {};
    let convertion = uom_conversions_to && !uom_conversions_to.includes(",") ? uom_conversions_to : uom_conversions_to && uom_conversions_to.includes(",") ? uom_conversions_to?.replace(/,/g, ".") : 0;

    const payload = {
      uom_category,
      uom_name,
      uom_category_code,
      uom_conversions_to: Number(convertion),
      uom_description,
      updated_at
    }

    const keys = {
      uom_category,
      uom_name,
      uom_category_code,
      uom_conversions_to,
      uom_description
    }

    for (const key in keys) {
      const option = validUOM(key, keys[key], t);
      const currentError = option;
      errors = { ...currentError, ...errors };
    }
    setError(errors);
    if (validateSubmit(errors)) {
      const { success, message } = await UOMServices.update(token, payload, id);
      if (success) {
        setVisible(true);
        setSuccessMessages(message)
      } else {
        setFailedModalOpen(true);
        setFailedMessages(message);
      }
    } else {
      setError(errors);
    }
  }

  const doGetManagementHistoryList = async (id) => {
    try {
      const response = await getManagementHistoryList(token, null, dispatch, id);
      if (response && response.ok) {
        const data = response.data
        const reorderedData = []

        for (let i = data.length - 1; i >= 0; i--) {
          const element = data[i];
          reorderedData.push(element)
        }

        setManagementHistoryList(reorderedData)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const convertTimestamp = (timestamp, isSpecific) => {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const monthNumbers = ["01", "02", "03", "04", "05", "06",
      "07", "08", "09", "10", "11", "12"
    ];

    // Extract components from the timestamp string
    const year = timestamp?.substring(0, 4);
    const month = timestamp?.substring(5, 7) - 1; // Months in JavaScript are 0-indexed
    const day = timestamp?.substring(8, 10);

    let dateFormat = new Date(year, month, day);

    if (isSpecific) {
      return (`${dateFormat.getDate()}-${monthNames[dateFormat.getMonth()]}-${dateFormat.getFullYear()}`)
    } else {
      return (`${dateFormat.getDate()}/${monthNumbers[dateFormat.getMonth()]}/${dateFormat.getFullYear()}`)
    }
  }

  const convertToTime = (timestamp) => {
    let time = new Date(timestamp);
    return (moment(timestamp).utc().format('HH:mm'))
  }

  const handleOk = () => {
    setVisible(false);
    handleBack();
  }

  return {
    handleBack,
    data,
    loading,
    _onChange,
    list,
    setList,
    _onSave,
    visible,
    handleOk,
    uom_category,
    uom_name,
    uom_category_code,
    uom_conversions_to,
    uom_description,
    updated_at,
    err,
    error,
    failedModalOpen,
    failedMessages,
    successMessages,
    setFailedModalOpen,
    showConfirm,
    setShowConfirm,
    managementHistoryList,
    convertTimestamp,
    convertToTime
  }
}

export default useEditUOM;